import generateID from '../reducer/generateID';

export const createCategory = (props) => {
  return {
    type: "CREATE_CATEGORY",
    props: props,
    id: generateID()
  }
}

export const updateCategory = (id, props) => {
  return {
    type: "UPDATE_CATEGORY",
    props: props,
    id: id
  }
}

export const deleteCategory = (id, reassignmentCategoryID) => {
  return {
    type: "DELETE_CATEGORY",
    id,
    reassignmentCategoryID
  }
}
